import React, {Component, useRef} from 'react';
import {renderToString} from 'react-dom/server';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import YieldlockCalculator from "../../components/yieldlock-calculator/component";
import BoosterHeader from "../../components/booster-header/component";
import DropdownTabs from "../../components/dropdown-tabs/component";
import Dropdown from "../../components/dropdown/component";
import DropdownSliderPrice from "../../components/dropdown-slider-price/component";
import {scroller, Element} from 'react-scroll';
import YieldlockPdf from "../yieldlock-pdf/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {collectedRegister} from "../../services/collectedRegister";
import {yieldlockRegister} from "../../services/yieldlockRegister";
import {themeRegister} from "../../services/themeRegister";
import {flowRegister} from "../../services/flowRegister";
import {imagesRegister} from "../../services/imagesRegister";
import queryString from "query-string";
import {dataRegister} from "../../services/dataRegister";
import {scraperRegister} from "../../services/scraperRegister";
import {tokenRegister} from "../../services/tokenRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";

const ref = React.createRef();

class BoosterYieldlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currencies: {
                options: [],
                placeholder: "Currency",
                error: false,
                disabled: false,
                value: "-1"
            },
            tabs: {
                options: [
                    {id: 'sell-to-stay', title: this.renders.text("item_41")},
                    {id: 'sell-to-let', title: this.renders.text("item_42")}
                ],
                value: {id: 'sell-to-let', title: this.renders.text("item_42")},
                disabled: false
            },
            locking_years: {
                options: [
                    {id: 3, title: '3 Years', years: 3},
                    {id: 4, title: '4 Years', years: 4},
                    {id: 5, title: '5 Years', years: 5},
                    {id: 6, title: '6 Years', years: 6},
                    {id: 7, title: '7 Years', years: 7}
                ],
                placeholder: "Set term",
                value: '-1',
                error: false
            },
            market_price: {
                disabled: false,
                error: false,
                currency: "AED",
                value: 0
            },
            market_rent: {
                disabled: false,
                error: false,
                currency: "AED",
                value: 0
            },
            discounts: {
                options: [],
                placeholder: "Discount",
                error: false,
                disabled: false,
                value: "-1"
            },
            dldwaivers: {
                options: [],
                placeholder: "DLD Waiver",
                error: false,
                disabled: false,
                value: "-1"
            },
            cheques: {
                options: [],
                placeholder: "Cheques",
                error: false,
                disabled: false,
                value: "-1"
            },
            freemonths: {
                options: [],
                placeholder: "Free months",
                error: false,
                disabled: false,
                value: "-1"
            },
            downpayments: {
                options: [],
                placeholder: "Down Payment",
                error: false,
                disabled: false,
                value: "-1"
            },
            finance: {
                options: [],
                placeholder: "Finance",
                error: false,
                disabled: false,
                value: "-1"
            },
            roi: {
                options: [],
                placeholder: "ROI",
                error: false,
                disabled: false,
                value: "-1"
            },
            paymentplan: {
                options: [],
                placeholder: "Payment Plan",
                error: false,
                disabled: false,
                value: "-1"
            },
            servicecharge: {
                options: [],
                placeholder: "Service Charge",
                error: false,
                disabled: false,
                value: "-1"
            },
            calculated: false,
            list_price: 0,
            up_front: false,
            google: {},
            industry: "",
            amenities: [],
            user_data: {},
            step_1: {
                options: [
                    {id: 0, title: '0%'},
                    {id: 10, title: '10%'},
                    {id: 20, title: '20%'},
                    {id: 30, title: '30%'},
                    {id: 40, title: '40%'},
                    {id: 50, title: '50%'},
                    {id: 60, title: '60%'},
                    {id: 70, title: '70%'},
                    {id: 80, title: '80%'},
                    {id: 90, title: '90%'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_2: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_2A_1: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_3B_1: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_3B_2: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_2B_1: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            step_3A_1: {
                options: [
                    {id: 0, title: 'Yes'},
                    {id: 1, title: 'No'}
                ],
                placeholder: "Select",
                value: '-1',
                error: false
            },
            manual: true,
            rent_boost: {
                disabled: false,
                error: false,
                currency: "AED",
                value: 0
            },
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/calculator');
            ReactGA4.send({ hitType: "pageview", page: "/booster/calculator" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    };

    componentDidMount() {

        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }

        this.functions.user();

        if (window.location.search.indexOf("creative=manual") !== -1 && !yieldlockRegister.getValue("manual")) {
            yieldlockRegister.remove();
            this.setState({
                manual: false
            })
        }

        if(window.location.search.indexOf("creative=manual") !== -1){
            yieldlockRegister.setValue("manual", true);
            this.setState({
                manual: false
            })
        }

        if(window.location.search.indexOf("creative=manual") === -1 && yieldlockRegister.getValue("manual")){
            yieldlockRegister.remove();
        }

        if (collectedRegister.getValue("currency") && collectedRegister.getValue("base_currency")) {
            this.init.currencies(collectedRegister.getValue("base_currency"), JSON.parse(collectedRegister.getValue("currency")).title);
        }

        //GET MARKET PRICE
        if (!yieldlockRegister.getValue('market_price') || !yieldlockRegister.getValue('calculated')) {
            let price = collectedRegister.getValue('price');
            let currency = collectedRegister.getValue('base_currency');
            this.state.market_price.value = price ? parseInt(price) : 0;
            this.state.market_price.currency = currency ? currency : "AED";
            this.state.market_rent.currency = currency ? currency : "AED";
            this.setState({
                market_price: this.state.market_price,
                market_rent: this.state.market_rent
            }, () => {
                yieldlockRegister.setValue('market_price', this.state.market_price.value);
                yieldlockRegister.setValue('market_rent', this.state.market_rent.value);
            })
        }

        if (collectedRegister.getValue('base_currency')) {
            this.state.market_price.currency = collectedRegister.getValue('base_currency');
            this.state.market_rent.currency = collectedRegister.getValue('base_currency');
            this.setState({
                market_price: this.state.market_price,
                market_rent: this.state.market_rent
            })
        }

        if (collectedRegister.getValue('amenities')) {
            let amenities = collectedRegister.getValue('amenities');
            if (Array.isArray(amenities)) {
                this.setState({
                    amenities: amenities.filter((item) => {
                        return item.selected
                    }).map((item) => {
                        return item.title
                    })
                })
            }
        }

        let theme = themeRegister.getValue();

        if (typeof theme === 'object' && theme.first_title) {
            this.setState({
                industry: theme.first_title
            })
        }

        if (typeof theme === 'object' && theme.first_subtitle_long) {
            this.setState({
                location: theme.first_subtitle_long
            })
        }

        if (collectedRegister.getValue('bath')) {
            let baths = JSON.parse(collectedRegister.getValue('bath'));
            if (typeof baths === 'object' && baths.amount) {
                this.setState({
                    baths: baths.amount
                })
            }
        }

        if (collectedRegister.getValue('size')) {
            let size = JSON.parse(collectedRegister.getValue('size'));
            if (size) {
                this.setState({
                    sqft: size
                })
            }
        }

        if (collectedRegister.getValue('bed')) {
            let beds = JSON.parse(collectedRegister.getValue('bed'));
            if (typeof beds === 'object' && beds.amount) {
                this.setState({
                    beds: beds.amount
                })
            }
        }

        if (collectedRegister.getValue('status')) {
            let status = JSON.parse(collectedRegister.getValue('status'));
            if (typeof status === 'object' && status.title) {
                this.setState({
                    property_status: status.title
                })
            }
        }

        if (collectedRegister.getValue('status')) {
            let type = JSON.parse(collectedRegister.getValue('type'));
            if (typeof type === 'object' && type.title) {
                this.setState({
                    property_type: type.title
                })
            }
        }

        if (collectedRegister.getValue('google')) {
            let google = collectedRegister.getValue('google');
            if (typeof google === 'object' && google.autocomplete_lat && google.autocomplete_lng) {
                this.setState({
                    lat: google.autocomplete_lat,
                    lng: google.autocomplete_lng
                })
            }
        }

        if (imagesRegister.get("images")) {
            let images = imagesRegister.get("images");
            if (Array.isArray(images) && images.length > 0) {
                let image = null;
                if (typeof images[0] === "string") {
                    image = images[0];
                } else if (typeof images[0] === "object") {
                    image = images[0].url;
                }
                if (image) {
                    this.setState({
                        image: image
                    })
                }
            }
        }

        //GET MARKET PRICE
        if (yieldlockRegister.getValue('market_price') && yieldlockRegister.getValue('calculated')) {
            this.state.market_price.value = yieldlockRegister.getValue('market_price');
            this.setState({
                market_price: this.state.market_price
            })
        }

        //GET RENT BOOST
        if (yieldlockRegister.getValue('rent_boost')) {
            this.state.rent_boost.value = yieldlockRegister.getValue('rent_boost');
            this.setState({
                rent_boost: this.state.rent_boost
            })
        }

        //GET MARKET RENT
        if (yieldlockRegister.getValue('market_rent') && yieldlockRegister.getValue('calculated')) {
            this.state.market_rent.value = yieldlockRegister.getValue('market_rent');
            this.setState({
                market_rent: this.state.market_rent
            })
        } else {
            let rent = (this.state.market_price.value / 100) * 5;
            this.state.market_rent.value = Math.round(rent);
            this.setState({
                market_rent: this.state.market_rent
            }, () =>{
                this.state.rent_boost.value = Math.round(this.state.market_rent.value * 1.3);
                this.setState({
                    rent_boost: this.state.rent_boost
                });
            })
        }

        //GET BOOST RENT
        if (yieldlockRegister.getValue('rent_boost') && yieldlockRegister.getValue('calculated')) {
            this.state.rent_boost.value = yieldlockRegister.getValue('rent_boost');
            this.setState({
                rent_boost: this.state.rent_boost
            })
        }

        //GET LIST PRICE
        if (yieldlockRegister.getValue('list_price')) {
            this.state.list_price = yieldlockRegister.getValue('list_price');
            this.setState({
                list_price: this.state.list_price
            })
        }


        //GET YEARS
        if (yieldlockRegister.getValue('years') && yieldlockRegister.getValue('calculated')) {
            this.state.locking_years.value = yieldlockRegister.getValue('years');
            this.setState({
                locking_years: this.state.locking_years
            })
        }

        //GET TABS
        if (yieldlockRegister.getValue('tabs') && yieldlockRegister.getValue('calculated')) {
            this.state.tabs.value = yieldlockRegister.getValue('tabs');
            this.setState({
                tabs: this.state.tabs
            })
        } else {
            yieldlockRegister.setValue('tabs', this.state.tabs.value);
        }

        //GET CALCULATED
        if (yieldlockRegister.getValue('calculated')) {
            this.setState({
                calculated: yieldlockRegister.getValue('calculated')
            })
        }

        //UP FRONT
        if (yieldlockRegister.getValue('up_front')) {
            this.state.up_front = yieldlockRegister.getValue('up_front');
            this.setState({
                up_front: this.state.up_front
            })
        }

        //GET STEPS
        if (yieldlockRegister.getValue('step_1')) {
            this.state.step_1.value = yieldlockRegister.getValue('step_1');
            this.setState({
                step_1: this.state.step_1
            })
        }
        if (yieldlockRegister.getValue('step_2')) {
            this.state.step_2.value = yieldlockRegister.getValue('step_2');
            this.setState({
                step_2: this.state.step_2
            })
        }
        if (yieldlockRegister.getValue('step_2B_1')) {
            this.state.step_2B_1.value = yieldlockRegister.getValue('step_2B_1');
            this.setState({
                step_2B_1: this.state.step_2B_1
            })
        }
        if (yieldlockRegister.getValue('step_2A_1')) {
            this.state.step_2A_1.value = yieldlockRegister.getValue('step_2A_1');
            this.setState({
                step_2A_1: this.state.step_2A_1
            })
        }
        if (yieldlockRegister.getValue('step_3A_1')) {
            this.state.step_3A_1.value = yieldlockRegister.getValue('step_3A_1');
            this.setState({
                step_3A_1: this.state.step_3A_1
            })
        }
        if (yieldlockRegister.getValue('step_3B_1')) {
            this.state.step_3B_1.value = yieldlockRegister.getValue('step_3B_1');
            this.setState({
                step_3B_1: this.state.step_3B_1
            })
        }
        if (yieldlockRegister.getValue('step_3B_2')) {
            this.state.step_3B_2.value = yieldlockRegister.getValue('step_3B_2');
            this.setState({
                step_3B_2: this.state.step_3B_2
            })
        }

        // if(this.renders.reply(this.state.step_3B_2) === 0){

    }

    scraper = {};

    init = {
        currencies: (base, value) => {
            dataRegister.rates(base.toLowerCase()).then((response) => {
                try {
                    for (let key in response.rates) {
                        if (key.toLowerCase() === value.toLowerCase()) {
                            this.state.currencies.value = JSON.stringify({title: key, rate: response.rates[key]});
                        }
                        this.state.currencies.options.push({title: key, rate: response.rates[key]});
                    }
                    this.setState({currencies: this.state.currencies});
                } catch (e) {

                }
            }, (error) => {

            });
        }
    };

    functions = {
        next: () => {

            //SET THEME
            themeRegister.setTheme("promotion");

            //REVERT
            let slogan_extras_revert = flowRegister.getValue("slogan_extras_revert");
            let industries_mathces_revert = flowRegister.getValue("industries_mathces_revert");
            let main_image_title_revert = flowRegister.getValue("main_image_title_revert");
            let video_items_revert = flowRegister.getValue("video_items_revert");

            flowRegister.setValue("slogan_extras", slogan_extras_revert);
            flowRegister.setValue("industries_mathces", industries_mathces_revert);
            flowRegister.setValue("main_image_title", main_image_title_revert);
            flowRegister.setValue("video_items", video_items_revert);

            //GET DATA
            let slogan_extras = flowRegister.getValue("slogan_extras");
            let industries_mathces = flowRegister.getValue("industries_mathces");
            let main_image_title = flowRegister.getValue("main_image_title");
            let slides = flowRegister.getValue("video_items");

            //SET UPFRONT
            let up_front = yieldlockRegister.getValue("up_front");
            let slogan_activation = [];
            let slogan_validation = [];
            let slogan_action = [];

            if(up_front){

                //SLOGAN STEP
                slogan_activation = [
                    //GENERIC START HERE
                    "Looking For ROI Up-Front?",
                    "On-Plan With ROI Up-Front",
                    "ROI Up-Front Is Here",
                    "On-Plan Paying ROI Up-Front",
                    "On-Plan With Prepaid ROI",
                    "On-Plan With ROI Paid Up-Front",
                    "On-Plan With Real ROI Up-Front",
                    (this.renders.years() * this.state.yield) + "% ROI On Transfer",
                    (this.renders.years() * this.state.yield) + "% ROI On Hand Over",
                    "On-Plan With " + this.renders.years() + "Y ROI Up-Front",
                    "On-Plan With " + (this.renders.years() * this.state.yield) + "% ROI Up-Front",
                    "Future ROI Paid Today",
                    //"On-Plan With ROI Prepaid",
                    //INSERT START HERE
                    //"Roified [Type]",
                    //"Ready-2-ROI [Type]",
                    //"Prepaid ROI [Type]",
                    "[Type] With ROI Up-Front",
                    //"Prepaid ROI On [Type]",
                    "[Type] With Prepaid ROI"
                ];
                slogan_validation = [
                    "Sealed ROI",
                    "Secured ROI",
                    "Prepaid ROI",
                    "Assured ROI",
                    "Predictable ROI",
                    "Future ROI Paid Up-Front",
                    "Future ROI Banked Up-Front",
                    "Real ROI Not Promises",
                    "ROI Not Fancy Promises",
                    "ROI Not Broken Promises",
                    //this.renders.years() + "Y ROI On Transfer",
                    //(this.renders.years() * this.state.yield) + "% ROI On Transfer"
                ];
                slogan_action = [
                    "Hedge Your ROI Now",
                    "Bank Your ROI Now"
                ];
                for(let i = 0; i < slogan_activation.length; i++){
                    if(this.state.type === 1 && this.state.beds === 0){
                        slogan_extras.push({detail: "activation", title: slogan_activation[i].replace("[Type]", "Studio"), highlight: false});
                    }else{
                        slogan_extras.push({detail: "activation", title: slogan_activation[i].replace("[Type]", this.state.property_type), highlight: false});
                    }
                }
                for(let i = 0; i < slogan_validation.length; i++){
                    slogan_extras.push({detail: "validation", title: slogan_validation[i], highlight: false});
                }
                for(let i = 0; i < slogan_action.length; i++){
                    slogan_extras.push({detail: "action", title: slogan_action[i], highlight: false});
                }

                flowRegister.setValue("slogan_extras", slogan_extras);


                //MAIN IMAGE TITLE
                flowRegister.setValue("main_image_title", (this.renders.years() * this.state.yield) + "% ROI Up-Front");


                //VIDEO DATA
                let video_price = (JSON.parse(this.state.currencies.value).rate * +this.state.list_price);
                let video_currency = (JSON.parse(this.state.currencies.value).title);
                let video_title = "your effective price: " + video_currency + " " + this.renders.numberCommas(video_price - (video_price * ((this.renders.years() * this.state.yield) / 100))) + "*";

                /*
                if (video_title.length > 21) {
                    video_title = "your effective price " + video_currency + " " + Math.round(video_price - (video_price * ((this.renders.years() * this.state.yield) / 100)));
                }
                /*/

                slides.push({
                    label: null,
                    title: "buy this on-plan"
                });
                slides.push({
                    label: null,
                    title: "with " + (this.renders.years() * this.state.yield) + "% ROI"
                });
                slides.push({
                    label: null,
                    title: "paid up-front"
                });
                slides.push({
                    label: null,
                    title: video_title
                });
                slides.push({
                    label: null,
                    title: "a-plus assured"
                });
                slides.push({
                    label: null,
                    title: "verified deal"
                });
                slides.push({
                    label: null,
                    title: "all admin included"
                });

                /*
                slides.push({
                    label: null,
                    title: (this.renders.years() * this.state.yield) + "% ROI Up-Front"
                });
                /*/

                flowRegister.setValue("video_items", slides);

                //MATCH INDUSTRIES
                industries_mathces.push("roi up-front");
                industries_mathces.push("assured roi");
                industries_mathces.push("a+ assured");
                industries_mathces.push("all admin included");
                industries_mathces.push("property manager supervised");
                industries_mathces.push("escrow safeguarded");
                flowRegister.setValue("industries_mathces", industries_mathces);


                //SET ADS TITLE
                let ads_title_instagram = flowRegister.getValue("basic_ads_title_insta");
                ads_title_instagram = ads_title_instagram + (this.renders.years() * this.state.yield) + "% ROI Up-Front";

                let ads_title_facebook = flowRegister.getValue("basic_ads_title");
                ads_title_facebook = ads_title_facebook + (this.renders.years() * this.state.yield) + "% ROI Up-Front";

                let ads_title_google = flowRegister.getValue("basic_ads_title");
                ads_title_google = ads_title_google + (this.renders.years() * this.state.yield) + "% ROI Up-Front";

                let ads_title_bing = flowRegister.getValue("basic_ads_title");
                ads_title_bing = ads_title_bing + (this.renders.years() * this.state.yield) + "% ROI Up-Front";

                let company_name = (this.renders.years()*this.state.yield) + "% ROI Up-Front";

                flowRegister.setValue("company_name", company_name);
                flowRegister.setValue("ads_title_facebook", ads_title_facebook);
                flowRegister.setValue("ads_title_instagram", ads_title_instagram);
                flowRegister.setValue("ads_title_google", ads_title_google);
                flowRegister.setValue("ads_title_bing", ads_title_bing);

            }else{

                //SLOGAN STEP
                slogan_activation = [
                    //GENERIC START HERE
                    "Looking For Real Yield?",
                    "On-Plan With Yield Assured",
                    "Yield Hedge Is Here",
                    "On-Plan With Yield Hedge",
                    "On-Plan With Yieldlock",
                    "On-Plan With Real Yield",
                    this.state.yield + "% Yieldlock On Transfer",
                    this.state.yield + "% Yieldlock On Hand Over",
                    this.renders.years() + "Y Yieldlock On Transfer",
                    this.renders.years() + "Y Yieldlock On Hand Over",
                    "On-Plan With " + this.renders.years() + "Y Yield Assured",
                    "On-Plan With " + this.state.yield + "% Yield Assured",
                    "Future Yield Banked Today",
                    //INSERT START HERE
                    //"Yieldified [Type]",
                    //"Ready-2-Yield [Type]",
                    //"Yieldlocked [Type]",
                    "[Type] With Yield Hedge",
                    //"Yieldlock On [Type]",
                    "[Type] With Yieldlock"
                ];
                slogan_validation = [
                    "Sealed Yield",
                    "Yield Hedge",
                    "Secured Yield",
                    "Assured Yield",
                    "Predictable Yield",
                    "All Yield Hedged Up-Front",
                    "All Yield Banked Up-front",
                    "Real Yield Not Promises",
                    "Yield Not Fancy Promises",
                    "Yield Not Broken Promises",
                    //this.renders.years() + " Years Yield Assured",
                    //this.state.yield + "% Yield Assured"
                ];
                slogan_action = [
                    "Hedge Your Yield Now",
                    "Bank Your Yield Now"
                ];
                for(let i = 0; i < slogan_activation.length; i++){
                    if(this.state.type === 1 && this.state.beds === 0){
                        slogan_extras.push({detail: "activation", title: slogan_activation[i].replace("[Type]", "Studio"), highlight: false});
                    }else{
                        slogan_extras.push({detail: "activation", title: slogan_activation[i].replace("[Type]", this.state.property_type), highlight: false});
                    }
                }
                for(let i = 0; i < slogan_validation.length; i++){
                        slogan_extras.push({detail: "validation", title: slogan_validation[i], highlight: false});
                }
                for(let i = 0; i < slogan_action.length; i++){
                    slogan_extras.push({detail: "action", title: slogan_action[i], highlight: false});
                }

                flowRegister.setValue("slogan_extras", slogan_extras);


                //MAIN IMAGE TITLE
                flowRegister.setValue("main_image_title", this.state.yield + "% Yield Assured " + this.renders.years() + "Y");


                //VIDEO DATA
                let video_price = (JSON.parse(this.state.currencies.value).rate * +this.state.list_price);
                let video_currency = (JSON.parse(this.state.currencies.value).title);

                slides.push({
                    label: null,
                    title: "buy this on-plan"
                });
                slides.push({
                    label: null,
                    title: "with " + this.state.yield + "% real yield"
                });
                slides.push({
                    label: null,
                    title: "over " + this.renders.years() + " years"
                });
                slides.push({
                    label: null,
                    title: "banked up-front"
                });
                slides.push({
                    label: null,
                    title: "your effective price: " + video_currency + " " + this.renders.numberCommas(video_price - (video_price * ((this.renders.years() * this.state.yield) / 100))) + "*"
                });
                slides.push({
                    label: null,
                    title: "a-plus assured"
                });
                slides.push({
                    label: null,
                    title: "verified deal"
                });
                slides.push({
                    label: null,
                    title: "all admin included"
                });

                /*
                slides.push({
                    label: null,
                    title: this.state.yield + "% Yield Assured " + this.renders.years() + "Y"
                });
                /*/

                flowRegister.setValue("video_items", slides);


                //MATCH INDUSTRIES
                industries_mathces.push("yieldlock");
                industries_mathces.push("assured yield");
                industries_mathces.push("a+ assured");
                industries_mathces.push("all admin included");
                industries_mathces.push("property manager supervised");
                industries_mathces.push("escrow safeguarded");
                industries_mathces.push("assured future solvency");
                industries_mathces.push("assured future payouts");
                flowRegister.setValue("industries_mathces", industries_mathces);


                //SET ADS TITLE
                let ads_title_instagram = flowRegister.getValue("basic_ads_title_insta");
                ads_title_instagram = ads_title_instagram + this.state.yield + "% Yield Assured " + this.renders.years() + "Y";

                let ads_title_facebook = flowRegister.getValue("basic_ads_title");
                ads_title_facebook = ads_title_facebook + this.state.yield + "% Yield Assured " + this.renders.years() + "Y";

                let ads_title_google = flowRegister.getValue("basic_ads_title");
                ads_title_google = ads_title_google + this.state.yield + "% Yield Assured " + this.renders.years() + "Y";

                let ads_title_bing = flowRegister.getValue("basic_ads_title");
                ads_title_bing = ads_title_bing + this.state.yield + "% Yield Assured " + this.renders.years() + "Y";

                let company_name = this.state.yield + "% Yield Assured " + this.renders.years() + "Y";

                flowRegister.setValue("company_name", company_name);
                flowRegister.setValue("ads_title_facebook", ads_title_facebook);
                flowRegister.setValue("ads_title_instagram", ads_title_instagram);
                flowRegister.setValue("ads_title_google", ads_title_google);
                flowRegister.setValue("ads_title_bing", ads_title_bing);

            }

            //SET BELOW MARKET
            let below_market_percent = Math.round(100 - ((this.state.list_price/this.state.market_price.value) * 100));

            let exist = false;
            for(let i = 0; i < slogan_extras.length; i++){

                if (slogan_extras[i].title.indexOf('Below Market') !== -1) {
                    exist = true;
                    break;
                }
            }

            if (below_market_percent > 3 && !exist) {

                //SLOGAN STEP
                slogan_extras.push({detail: "offer", title: below_market_percent + "% Below Market"});
                flowRegister.setValue("slogan_extras", slogan_extras);

                //MATCH INDUSTRIES
                industries_mathces.push("below market price");
                flowRegister.setValue("industries_mathces", industries_mathces);

                //MAIN IMAGE TITLE
                flowRegister.setValue("main_image_title", below_market_percent + "% Below Market");


                //VIDEO DATA
                /*
                slides.push({
                    label: null,
                    title: below_market_percent + "% Below Market"
                });
                flowRegister.setValue("video_items", slides);
                /*/

            } else if (below_market_percent > 3 && exist) {

            } else {
                console.log("REVERT");
                quotesRegister.remove();
                quotesRegister.setView(null);
                cartRegister.setQuotes(null);
            }


            //SET AD PRICE
            let ads_price = (+this.state.list_price > 0 ? (JSON.parse(this.state.currencies.value).title + " " + this.renders.numberCommas((JSON.parse(this.state.currencies.value).rate * +this.state.list_price))) : "Price on request");

            collectedRegister.setValue("price", +this.state.list_price);

            themeRegister.setItem("last_title", ads_price);
            themeRegister.setItem("center_bottom", ads_price);
            //flowRegister.setValue("company_name", ads_price);

            if(this.state.inhouse && scraperRegister.getImagesAvailableBoolean() && scraperRegister.getImagesAvailableBoolean() !== "false"){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images?creative=manual");
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
            }

        },
        back: () => {

            yieldlockRegister.remove();

            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");

        },
        user: () => {
            dataRegister.account(salesChannelRegister.get('market')).then((response) => {
                this.setState({
                    user_data: response,
                    inhouse: response.inhouse,
                }, () => {
                    this.setState({
                        manual: this.state.manual,
                        user_data: this.state.user_data
                    })
                });
            }, (error) => {

            });
        },
        print: (type) => {

            var getUrl = window.location;
            var test = getUrl.href;

            if(window.location.search.indexOf("creative=manual") !== -1){
                test = test.replace('booster/calculator?creative=manual', 'pdf/yieldlock?');
            }else{
                test = test.replace('booster/calculator', 'pdf/yieldlock?');
            }

            let data = {
                type: type === "buyer" ? "buyer" : this.renders.type(),
                amenities: this.state.amenities,
                broker: false,
                lat: this.state.lat,
                lng: this.state.lng,
                location: this.state.location,
                industry: this.state.industry,
                beds: this.state.beds,
                property_type: this.state.property_type,
                property_status: this.state.property_status,
                baths: this.state.baths,
                sqft: this.state.sqft,
                sqm: this.state.sqm,
                image: this.state.image,
                market_rent: this.renders.marketRent(),
                market_price: this.renders.marketPrice(),
                list_rent: this.state.list_rent,
                years: this.renders.years(),
                list_price: this.state.list_price,
                yield: this.state.yield,
                currency: "AED",
                up_front: this.state.up_front,
                broker_image: this.state.user_data.profile_image,
                broker_email: this.state.user_data.email,
                broker_phone: this.state.user_data.phone,
                broker_name: this.state.user_data.name + " " + this.state.user_data.surname
            };
            console.log("up_front", this.state.up_front);
            let query = queryString.stringify(data);

            test = test + query;

            var w = window.open(test);

        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("booster-industry", item);
        },
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        numberCommas: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } catch (e) {
                return ("...")
            }
        },
        years: () => {
            try {
                return JSON.parse(this.state.locking_years.value).years
            } catch (e) {
                return 0
            }
        },
        type: () => {
            try {
                return this.state.tabs.value.id
            } catch (e) {
                return 0
            }
        },
        marketPrice: () => {
            try {
                return this.state.market_price.value
            } catch (e) {
                return 0
            }
        },
        marketRent: () => {
            try {
                return this.state.market_rent.value
            } catch (e) {
                return 0
            }
        },
        reply: (item) => {
            try {
                return JSON.parse(item.value).id;
            } catch (e) {
                return ""
            }
        },
        ltv: () => {
            try{
                let ltv = this.renders.reply(this.state.step_1) + 10;
                ltv = 100 - ltv;
                ltv = ltv / 100;
                ltv = this.state.list_price * ltv;
                let total_yield = this.renders.years() * ((this.state.yield/100) * this.state.list_price);
                console.log("total yield", total_yield);
                console.log("ltv", ltv);
                return total_yield > ltv;
            }catch (e) {
                return false
            }
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader analyzing={true} props={this.props}/>
                <div className={Styles.container}>
                    <Element name="top" className="top"></Element>
                    <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                         className={Styles.title}>
                        <div>
                            {this.renders.text("item_40")}
                        </div>
                    </div>
                    <div className={Styles.optionsContainer}>
                        {
                            ///STEP 1
                            this.state.manual &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Property loan-to-value ratio?
                                </div>
                                <Dropdown
                                    options={this.state.step_1.options}
                                    error={this.state.manual && this.renders.reply(this.state.step_1) > 50}
                                    placeholder={this.state.step_1.placeholder}
                                    value={this.state.step_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_1.value = value;
                                        this.setState({
                                            step_1: this.state.step_1
                                        }, () => {

                                            yieldlockRegister.setValue('step_1', this.state.step_1.value);
                                            yieldlockRegister.setValue(null);

                                            //RESET ALL STEPS BELOW
                                            this.state.step_2.value = "-1";
                                            this.state.step_2A_1.value = "-1";
                                            this.state.step_2B_1.value = "-1";
                                            this.state.step_3A_1.value = "-1";
                                            this.state.step_3B_1.value = "-1";
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_2: this.state.step_2,
                                                step_2A_1: this.state.step_2A_1,
                                                step_2B_1: this.state.step_2B_1,
                                                step_3A_1: this.state.step_3A_1,
                                                step_3B_1: this.state.step_3B_1,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_1) > 50 &&
                            <div className={cx(Styles.errorMessage)}>
                                Loan-to-value ratio is too high
                            </div>
                        }
                        {
                            ///STEP 2
                            this.state.manual && this.renders.reply(this.state.step_1) <= 50 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Seller looking to sell-to-stay?
                                </div>
                                <Dropdown
                                    options={this.state.step_2.options}
                                    error={this.state.step_2.error}
                                    placeholder={this.state.step_2.placeholder}
                                    value={this.state.step_2.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_2.value = value;
                                        let answer = JSON.parse(value);
                                        if (answer.id === 0) {
                                            this.state.tabs.value = {
                                                id: 'sell-to-stay',
                                                title: this.renders.text("item_41")
                                            };
                                        } else {
                                            this.state.tabs.value = {
                                                id: 'sell-to-let',
                                                title: this.renders.text("item_42")
                                            };
                                        }
                                        this.setState({
                                            step_2: this.state.step_2,
                                            tabs: this.state.tabs
                                        }, () => {

                                            //RESET ALL STEPS BELOW
                                            this.state.step_2A_1.value = "-1";
                                            this.state.step_2B_1.value = "-1";
                                            this.state.step_3A_1.value = "-1";
                                            this.state.step_3B_1.value = "-1";
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_2A_1: this.state.step_2A_1,
                                                step_2B_1: this.state.step_2B_1,
                                                step_3A_1: this.state.step_3A_1,
                                                step_3B_1: this.state.step_3B_1,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            ///STEP 2A-1
                            //SHOW IF STEP 2 IS YES (0)
                            this.state.manual && this.renders.reply(this.state.step_2) === 0 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Seller ok with value release around market price in exchange for quicker sale?
                                </div>
                                <Dropdown
                                    options={this.state.step_2A_1.options}
                                    error={this.state.step_2A_1.error}
                                    placeholder={this.state.step_2A_1.placeholder}
                                    value={this.state.step_2A_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_2A_1.value = value;
                                        this.setState({
                                            step_2A_1: this.state.step_2A_1
                                        }, () => {

                                            //RESET ALL STEPS BELOW
                                            this.state.step_2B_1.value = "-1";
                                            this.state.step_3A_1.value = "-1";
                                            this.state.step_3B_1.value = "-1";
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_2B_1: this.state.step_2B_1,
                                                step_3A_1: this.state.step_3A_1,
                                                step_3B_1: this.state.step_3B_1,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            ///STEP 2A-1 MARKET PRICE
                            //SHOW IF STEP 2 IS YES (0)
                            this.state.manual && this.renders.reply(this.state.step_2) === 0 && this.renders.reply(this.state.step_2A_1) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_43")}
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_price.error}
                                    currency={this.state.market_price.currency}
                                    value={this.state.market_price.value}
                                    onChange={(value) => {
                                        this.state.market_price.value = value;
                                        this.setState({
                                            market_price: this.state.market_price
                                        }, () => {
                                            yieldlockRegister.setValue('market_price', this.state.market_price.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 0 && this.renders.reply(this.state.step_2A_1) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_44")}{" "}(long-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_rent.error}
                                    currency={this.state.market_rent.currency}
                                    value={this.state.market_rent.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.market_rent.value = value;
                                        this.setState({
                                            market_rent: this.state.market_rent
                                        }, () => {
                                            yieldlockRegister.setValue('market_rent', this.state.market_rent.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 0 && this.renders.reply(this.state.step_2A_1) < 2 &&
                            <div className={Styles.optionsContainerSection}>
                                <Dropdown
                                    options={this.state.locking_years.options}
                                    error={this.state.locking_years.error}
                                    placeholder={this.state.locking_years.placeholder}
                                    value={this.state.locking_years.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.locking_years.value = value;
                                        this.setState({
                                            locking_years: this.state.locking_years
                                        }, () => {
                                            yieldlockRegister.setValue('years', this.state.locking_years.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            //STEP 2B-1
                            //SHOW IF STEP 2 IS NO (1)
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Property suitable for short-term lease?
                                </div>
                                <Dropdown
                                    options={this.state.step_2B_1.options}
                                    error={this.state.step_2B_1.error}
                                    placeholder={this.state.step_2B_1.placeholder}
                                    value={this.state.step_2B_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_2B_1.value = value;
                                        this.setState({
                                            step_2B_1: this.state.step_2B_1
                                        }, () => {

                                            //RESET ALL STEPS BELOW
                                            this.state.step_3A_1.value = "-1";
                                            this.state.step_3B_1.value = "-1";
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_3A_1: this.state.step_3A_1,
                                                step_3B_1: this.state.step_3B_1,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            //STEP 3A-1
                            //SHOW IF STEP 2 IS NO (1) AND STEP 2B-1 IS YES (1)
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 1 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Seller ok with value release around market price in exchange for quicker sale?
                                </div>
                                <Dropdown
                                    options={this.state.step_3A_1.options}
                                    error={this.state.step_3A_1.error}
                                    placeholder={this.state.step_3A_1.placeholder}
                                    value={this.state.step_3A_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_3A_1.value = value;
                                        this.setState({
                                            step_3A_1: this.state.step_3A_1
                                        }, () => {

                                            //RESET ALL STEPS BELOW
                                            this.state.step_3B_1.value = "-1";
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_3B_1: this.state.step_3B_1,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            ///STEP 3A-1 MARKET PRICE
                            //SHOW IF STEP 2 IS NO (1)
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_3A_1) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_43")}
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_price.error}
                                    currency={this.state.market_price.currency}
                                    value={this.state.market_price.value}
                                    onChange={(value) => {
                                        this.state.market_price.value = value;
                                        this.setState({
                                            market_price: this.state.market_price
                                        }, () => {
                                            yieldlockRegister.setValue('market_price', this.state.market_price.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_3A_1) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_44")}{" "}(long-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_rent.error}
                                    currency={this.state.market_rent.currency}
                                    value={this.state.market_rent.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.market_rent.value = value;
                                        this.setState({
                                            market_rent: this.state.market_rent
                                        }, () => {
                                            yieldlockRegister.setValue('market_rent', this.state.market_rent.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_3A_1) < 2 &&
                            <div className={Styles.optionsContainerSection}>
                                <Dropdown
                                    options={this.state.locking_years.options}
                                    error={this.state.locking_years.error}
                                    placeholder={this.state.locking_years.placeholder}
                                    value={this.state.locking_years.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.locking_years.value = value;
                                        this.setState({
                                            locking_years: this.state.locking_years
                                        }, () => {
                                            yieldlockRegister.setValue('years', this.state.locking_years.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            //STEP 3B-1
                            //
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 0 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Seller looking for a quick sale?
                                </div>
                                <Dropdown
                                    options={this.state.step_3B_1.options}
                                    error={this.state.step_3B_1.error}
                                    placeholder={this.state.step_3B_1.placeholder}
                                    value={this.state.step_3B_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_3B_1.value = value;
                                        this.setState({
                                            step_3B_1: this.state.step_3B_1
                                        }, () => {

                                            //RESET ALL STEPS BELOW
                                            this.state.step_3B_2.value = "-1";
                                            this.state.locking_years.value = "-1";
                                            this.setState({
                                                locking_years: this.state.locking_years,
                                                step_3B_2: this.state.step_3B_2
                                            })

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            //STEP 3B-2
                            //
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 0 && this.renders.reply(this.state.step_3B_1) < 2 &&
                            <div className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Seller ok with higher risk to maximize rental income?
                                </div>
                                <Dropdown
                                    options={this.state.step_3B_2.options}
                                    error={this.state.step_3B_2.error}
                                    placeholder={this.state.step_3B_2.placeholder}
                                    value={this.state.step_3B_2.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_3B_2.value = value;
                                        this.setState({
                                            step_3B_2: this.state.step_3B_2
                                        }, () => {

                                            //UPDATE BOOST RENT
                                            if(this.renders.reply(this.state.step_3B_2) === 0){
                                                this.state.rent_boost.value = Math.round(this.state.market_rent.value * 1.3);
                                                this.setState({
                                                    rent_boost: this.state.rent_boost,
                                                }, () => {
                                                    yieldlockRegister.setValue('rent_boost', this.state.rent_boost.value);
                                                })
                                            }

                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            ///STEP 3B-1/2 MARKET PRICE
                            //
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 0 && this.renders.reply(this.state.step_3B_1) < 2 && this.renders.reply(this.state.step_3B_2) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_43")}
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_price.error}
                                    currency={this.state.market_price.currency}
                                    value={this.state.market_price.value}
                                    onChange={(value) => {
                                        this.state.market_price.value = value;
                                        this.setState({
                                            market_price: this.state.market_price
                                        }, () => {
                                            yieldlockRegister.setValue('market_price', this.state.market_price.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 0 && this.renders.reply(this.state.step_3B_1) < 2 && this.renders.reply(this.state.step_3B_2) < 2 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_44")}{" "}(long-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_rent.error}
                                    currency={this.state.market_rent.currency}
                                    value={this.state.market_rent.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.market_rent.value = value;
                                        this.setState({
                                            market_rent: this.state.market_rent
                                        }, () => {
                                            yieldlockRegister.setValue('market_rent', this.state.market_rent.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_3B_2) === 0 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Estimated market rent (short-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.rent_boost.error}
                                    currency={this.state.rent_boost.currency}
                                    value={this.state.rent_boost.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.rent_boost.value = value;
                                        this.setState({
                                            rent_boost: this.state.rent_boost
                                        }, () => {
                                            yieldlockRegister.setValue('rent_boost', this.state.rent_boost.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            this.state.manual && this.renders.reply(this.state.step_2) === 1 && this.renders.reply(this.state.step_2B_1) === 0 && this.renders.reply(this.state.step_3B_1) < 2 && this.renders.reply(this.state.step_3B_2) < 2 &&
                            <div className={Styles.optionsContainerSection}>
                                <Dropdown
                                    options={this.state.locking_years.options}
                                    error={this.state.locking_years.error}
                                    placeholder={this.state.locking_years.placeholder}
                                    value={this.state.locking_years.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.locking_years.value = value;
                                        this.setState({
                                            locking_years: this.state.locking_years
                                        }, () => {
                                            yieldlockRegister.setValue('years', this.state.locking_years.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                           !this.state.manual &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}>
                                <DropdownTabs
                                    options={this.state.tabs.options}
                                    disabled={this.state.calculated}
                                    value={this.state.tabs.value}
                                    onChange={(value) => {
                                        this.state.tabs.value = value;
                                        this.setState({
                                            tab: value
                                        }, () => {
                                            yieldlockRegister.setValue('tabs', this.state.tabs.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            !this.state.manual && this.state.tabs.value.id === "sell-to-let" &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}} className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Property suitable for short-term lease?
                                </div>
                                <Dropdown
                                    options={this.state.step_2B_1.options}
                                    error={this.state.step_2B_1.error}
                                    placeholder={this.state.step_2B_1.placeholder}
                                    value={this.state.step_2B_1.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.step_2B_1.value = value;
                                        this.setState({
                                            step_2B_1: this.state.step_2B_1
                                        }, () => {
                                            if(this.renders.reply(this.state.step_2B_1) === 1){
                                                this.state.rent_boost.value = this.state.market_rent.value;
                                                this.setState({
                                                    rent_boost: this.state.rent_boost
                                                }, () => {
                                                    yieldlockRegister.setValue('rent_boost', this.state.rent_boost.value);
                                                })
                                            }
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            !this.state.manual &&  ((this.renders.reply(this.state.step_2B_1) === 0 || this.renders.reply(this.state.step_2B_1) === 1) || this.state.tabs.value.id === "sell-to-stay") &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}} className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                        Set term
                                </div>
                                <Dropdown
                                    options={this.state.locking_years.options}
                                    error={this.state.locking_years.error}
                                    placeholder={this.state.locking_years.placeholder}
                                    value={this.state.locking_years.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.locking_years.value = value;
                                        this.setState({
                                            locking_years: this.state.locking_years
                                        }, () => {
                                            yieldlockRegister.setValue('years', this.state.locking_years.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            !this.state.manual && ((this.renders.reply(this.state.step_2B_1) === 0 || this.renders.reply(this.state.step_2B_1) === 1) || this.state.tabs.value.id === "sell-to-stay") &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_43")}
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_price.error}
                                    currency={this.state.market_price.currency}
                                    value={this.state.market_price.value}
                                    onChange={(value) => {
                                        this.state.market_price.value = value;
                                        this.setState({
                                            market_price: this.state.market_price
                                        }, () => {
                                            yieldlockRegister.setValue('market_price', this.state.market_price.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            !this.state.manual && ((this.renders.reply(this.state.step_2B_1) === 0 || this.renders.reply(this.state.step_2B_1) === 1) || this.state.tabs.value.id === "sell-to-stay") &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    {this.renders.text("item_44")}{" "}(long-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.market_rent.error}
                                    currency={this.state.market_rent.currency}
                                    value={this.state.market_rent.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.market_rent.value = value;
                                        this.setState({
                                            market_rent: this.state.market_rent
                                        }, () => {
                                            yieldlockRegister.setValue('market_rent', this.state.market_rent.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            !this.state.manual && this.state.tabs.value && this.state.tabs.value.id === "sell-to-let" && this.renders.reply(this.state.step_2B_1) === 0 &&
                            <div style={this.state.calculated ? {opacity: 0.3} : {}}
                                 className={Styles.optionsContainerSection}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.optionsContainerSectionTitle}>
                                    Estimated market rent (short-term)
                                </div>
                                <DropdownSliderPrice
                                    disabled={this.state.calculated}
                                    error={this.state.rent_boost.error}
                                    currency={this.state.rent_boost.currency}
                                    value={this.state.rent_boost.value}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.state.rent_boost.value = value;
                                        this.setState({
                                            rent_boost: this.state.rent_boost
                                        }, () => {
                                            yieldlockRegister.setValue('rent_boost', this.state.rent_boost.value);
                                        })
                                    }}
                                />
                            </div>
                        }
                        {
                            <div className={Styles.buttonContainer}>
                                <div
                                    style={(this.state.locking_years.value === "-1") ? {backgroundColor: "#BFBFBF"} : {}}
                                    onClick={() => {
                                        if (this.state.locking_years.value !== "-1") {

                                            //SET LIST_PRICE
                                            if (!this.state.manual) {

                                                this.state.list_price = this.state.market_price.value;
                                                if(this.state.tabs.value && this.state.tabs.value.id === "sell-to-stay"){
                                                    this.state.list_rent = this.state.market_rent.value;
                                                }else{
                                                    this.state.list_rent = this.state.rent_boost.value;
                                                }

                                            } else {

                                                if(this.renders.reply(this.state.step_2A_1) === 1 || this.renders.reply(this.state.step_3A_1) === 1){

                                                    this.state.list_price = Math.round(this.state.market_price.value * 1.1);
                                                    this.state.list_rent = this.state.market_rent.value;

                                                }else if(this.renders.reply(this.state.step_2B_1) === 0){

                                                    if(this.renders.reply(this.state.step_3B_1) === 0 && this.renders.reply(this.state.step_3B_2) === 1){
                                                        //3B-1 —> true + 3B-2 —> false
                                                        this.state.list_price = this.state.market_price.value;
                                                        this.state.list_rent = this.state.market_rent.value;
                                                    }else if(this.renders.reply(this.state.step_3B_1) === 1 && this.renders.reply(this.state.step_3B_2) === 1){
                                                        //3B-1 —> false + 3B-2 —> false
                                                        this.state.list_price = Math.round(this.state.market_price.value * 1.1);
                                                        this.state.list_rent = this.state.market_rent.value;
                                                    }else if(this.renders.reply(this.state.step_3B_1) === 0 && this.renders.reply(this.state.step_3B_2) === 0){
                                                        //3B-1 —> true + 3B-2 —> true
                                                        let years = 1;
                                                        try{
                                                            years = JSON.parse(this.state.locking_years.value).id;
                                                        }catch (e) {
                                                            console.log(e);
                                                        }

                                                        this.state.list_price = Math.round(this.state.market_price.value - ((this.state.market_rent.value * 0.3) * +years));
                                                        this.state.list_rent = this.state.rent_boost.value;

                                                    }else if(this.renders.reply(this.state.step_3B_1) === 1 && this.renders.reply(this.state.step_3B_2) === 0){
                                                        //3B-1 —> false + 3B-2 —> true


                                                        this.state.list_price = this.state.market_price.value;
                                                        this.state.list_rent = this.state.rent_boost.value;


                                                    }else{
                                                        this.state.list_price = this.state.market_price.value;
                                                        this.state.list_rent = this.state.market_rent.value;
                                                    }

                                                }else{

                                                    this.state.list_price = this.state.market_price.value;
                                                    this.state.list_rent = this.state.market_rent.value;

                                                }

                                            }

                                            this.setState({
                                                calculated: !this.state.calculated,
                                                list_price: this.state.list_price,
                                                list_rent: this.state.list_rent
                                            }, () => {
                                                if (this.state.calculated) {

                                                    scroller.scrollTo('calculator', {
                                                        duration: 600,
                                                        delay: 0,
                                                        offset: 0,
                                                        smooth: 'easeInOutQuart'
                                                    });

                                                    yieldlockRegister.setValue("step_1", this.state.step_1.value);
                                                    yieldlockRegister.setValue("step_2", this.state.step_2.value);
                                                    yieldlockRegister.setValue("step_2B_1", this.state.step_2B_1.value);
                                                    yieldlockRegister.setValue("step_2A_1", this.state.step_2A_1.value);
                                                    yieldlockRegister.setValue("step_3A_1", this.state.step_3A_1.value);
                                                    yieldlockRegister.setValue("step_3B_1", this.state.step_3B_1.value);
                                                    yieldlockRegister.setValue("step_3B_2", this.state.step_3B_2.value);

                                                } else {

                                                    scroller.scrollTo('top', {
                                                        duration: 600,
                                                        delay: 0,
                                                        offset: 150,
                                                        smooth: 'easeInOutQuart'
                                                    });

                                                    //RESET ALL STEPS BELOW
                                                    this.state.step_1.value = "-1";
                                                    this.state.step_2.value = "-1";
                                                    this.state.step_2A_1.value = "-1";
                                                    this.state.step_2B_1.value = "-1";
                                                    this.state.step_3A_1.value = "-1";
                                                    this.state.step_3B_1.value = "-1";
                                                    this.state.step_3B_2.value = "-1";
                                                    this.setState({
                                                        up_front: false,
                                                        step_1: this.state.step_1,
                                                        step_2: this.state.step_2,
                                                        step_2A_1: this.state.step_2A_1,
                                                        step_2B_1: this.state.step_2B_1,
                                                        step_3A_1: this.state.step_3A_1,
                                                        step_3B_1: this.state.step_3B_1,
                                                        step_3B_2: this.state.step_3B_2
                                                    }, () => {
                                                        yieldlockRegister.setValue("up_front", null);
                                                        yieldlockRegister.setValue("step_1", null);
                                                        yieldlockRegister.setValue("step_2", null);
                                                        yieldlockRegister.setValue("step_2B_1", null);
                                                        yieldlockRegister.setValue("step_2A_1", null);
                                                        yieldlockRegister.setValue("step_3A_1", null);
                                                        yieldlockRegister.setValue("step_3B_1", null);
                                                        yieldlockRegister.setValue("step_3B_2", null);
                                                    })

                                                }
                                                yieldlockRegister.setValue("yield", null);
                                                yieldlockRegister.setValue("list_price", null);
                                                yieldlockRegister.setValue('calculated', this.state.calculated);
                                            })
                                        }
                                    }} className={cx(Styles.button)}>
                                    {!this.state.calculated && this.renders.text("item_45")}
                                    {this.state.calculated && this.renders.text("item_46")}
                                </div>
                                {
                                    !this.state.calculated &&
                                    <div onClick={() => {
                                        this.functions.back();
                                    }}
                                         style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                         className={Styles.backButton}>
                                        {this.renders.text("item_9")}
                                    </div>
                                }
                            </div>
                        }
                        {
                            this.state.calculated &&
                            <div className={Styles.arrowDown}>
                                <img className={Styles.arrowDownItem}
                                     src={require('../../assets/images/AB_arrow_down.png')}/>
                            </div>
                        }
                        <Element name="calculator" className="calculator"></Element>
                        {
                            this.state.calculated &&
                            <YieldlockCalculator
                                ltvWarning={this.renders.ltv()}
                                years={this.renders.years()}
                                market_price={this.renders.marketPrice()}
                                market_rent={this.state.list_rent}
                                list_price={this.state.list_price}
                                up_front={this.state.up_front}
                                inhouse={this.state.inhouse}
                                updateUpfront={(value) => {
                                    this.setState({
                                        up_front: value
                                    })
                                }}
                                updateListPrice={(value) => {
                                    this.setState({
                                        list_price: value
                                    }, () => {
                                        yieldlockRegister.setValue('list_price', this.state.list_price);
                                    })
                                }}
                                updateYield={(value) => {
                                    this.setState({
                                        yield: value
                                    }, () => {
                                        yieldlockRegister.setValue('yield', this.state.yield);
                                    })
                                }}
                            />
                        }
                        {
                            this.state.calculated &&
                            <div className={Styles.downloadButtons}>
                                <div onClick={() => {
                                    this.functions.print('seller');
                                }} className={Styles.downloadButtonsItem}>
                                    <img className={Styles.downloadButtonsItemIcon}
                                         src={require('../../assets/images/YS_Icon_Sheet.png')}/>
                                    <span className={Styles.downloadButtonsItemText}>Print proposal</span>
                                    <span className={Styles.downloadButtonsItemTextBold}>to seller</span>
                                </div>
                                <div onClick={() => {
                                    this.functions.print('buyer');
                                }} className={Styles.downloadButtonsItem}>
                                    <img className={Styles.downloadButtonsItemIcon}
                                         src={require('../../assets/images/YS_Icon_Sheet.png')}/>
                                    <span className={Styles.downloadButtonsItemText}>Print proposal</span>
                                    <span className={Styles.downloadButtonsItemTextBold}>to buyer</span>
                                </div>
                            </div>
                        }
                        {
                            this.state.calculated &&
                            <div className={Styles.buttonContainer}>
                                <div style={this.renders.ltv()?{backgroundColor: "#BFBFBF"}:{}} onClick={() => {
                                    if(!this.renders.ltv()){
                                        this.functions.next();
                                    }
                                }} className={cx(Styles.button)}>
                                    {this.renders.text("item_8")}
                                </div>
                                <div onClick={() => {
                                    this.functions.back();
                                }} style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                     className={Styles.backButton}>
                                    {this.renders.text("item_9")}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterYieldlock;


// WEBPACK FOOTER //
// ./src/pages/booster-yieldlock/component.js